import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import {Back2, ContBack2, ContImg, ContTitleHome, ImageHome, SubTitleHome, ContButton} from './Home.styles';
import ButtonSpecial from '../ButtonSpecial';
import Image from '../../assets/images/core-bancario-2.webp';
import ImageBack2 from '../../assets/images/back-home-complete-2.webp';
import {useWindowDimensions} from '../../utils';
import TitleSpecial from '../TitleSpecial';
import SEO from '../SEO';


export const Home = () => {
  const { t, i18n } = useTranslation();
  const {width} = useWindowDimensions();
  const [imgBack, setImgBack] = useState();

  useEffect(() => {
    // console.log('width =>', width);
    setImgBack(parseInt(width, 10) >= 1024 ? ImageBack2 : ImageBack2);
  }, [width]);

  useEffect(() => {
    // console.log('imgBack =>', imgBack);
  }, [imgBack]);

  return (
    <>
      <SEO
        title={t("Core bancario y plataforma Fintech")}
        description={t('Escala tu fintech con tecnología avanzada, Core Bancario más innovación. Digitaliza y acelera el lanzamiento de tus productos financieros.')}
        keywords={[
          t("Core Financiero"),
          t("Administración"),
          t("Transacciones"),
          t("Finanzas")
        ]}
        ogImage={Image}
        twitterImage={Image}
        canonicalUrl={`https://dynamicore.io${i18n.language === 'en' ? '/en' : ''}`}
        hreflang={[
          { url: "https://dynamicore.io", lang: "es" },
          { url: "https://dynamicore.io/en", lang: "en-us" }
        ]}
      />

      <div className={'section-first container-fit'} id={'section-first container-fit'}>
        <ContTitleHome>
          {width >= 600 ? (
            <TitleSpecial>
              {t('Transformamos tu financiera')} <br /> {t('desde el core')}
            </TitleSpecial>
          ) : (
            <TitleSpecial>
              {t('Transformamos tu financiera desde el core')}
            </TitleSpecial>
          )}

          <SubTitleHome>
            {t('El primer Core Financiero que te permite')} {' '}
            <span>{t('configurar productos financieros, administrar transacciones y simplificar operaciones')}</span>{' '}
            {t('de principio a fin.')}
          </SubTitleHome>

          <ContButton id={'ContButtonLeft'}>
            <ButtonSpecial
              text={'Prueba la versión Demo'}
              type={'/'}
              linkTo={'/contacto'}
              target={'_self'}
            />
          </ContButton>
        </ContTitleHome>

        <ContImg id={'ContImg'}>
          <ImageHome src={Image} alt={'Core Bancario'}/>
        </ContImg>

        <ContBack2 id={'ContBack2'}>
          <Back2 id={'imgBack2'} src={imgBack} alt={'Fondo de sección'}/>
        </ContBack2>
      </div>
    </>
);
};

